<template>
  <div>
    <!-- <altmenu
      :alan="alan"
      :unvan="unvan"
    /> -->

    <div class="col-12 p-0">
      <div class="row">
        <div class="col-md-9 p-0">
          <div class="white-bg px-2 py-3 relative">
            <h2 class="h2">{{obj.baslik}}</h2>
            <div class="d-flex" style="position: absolute; top:8px; right: 15px" >

            <!-- <button style="height: 40px;"
                  @click="deletustampon(posts)"
                  class="btn btn-yellow mb-5"
                >
                  <span style="font-size:15px">Seçilenleri Sil</span>
                </button> -->

            </div>
            <table class="table">
              <thead>
                <tr class="bg-light">
                  <th>No</th>
                  <th>Kod</th>
                  <!-- <th>Marka</th> -->
                  <th>Açıklama</th>
                  <th>Miktar</th>
                  <th>Birim</th>
                  <th>Liste</th>
                  <th>İskontolu</th>
                  <th>İsk (%)</th>
                  <th>Kdv</th>
                  <th>Tutar</th>
                  <th>Net Fiyat</th>
                  <th>Geri</th>
                  <th>Onay</th>

                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in posts" :key="index">
                  <td class="product-name" style="padding-top:13px">
                    {{ item.sid }}

                  </td>

                                     <td class="product-name" data-label="Product">
                    {{ item.kod }}

                  </td>
                  <!-- <td class="product-name" data-label="Product">
                    {{ item.marka }}

                  </td> -->

                  <td class="product-name" data-title="Product">
                    <span class="d-block">
                      {{
                        $helper.ilkharfBuyuk(item.isim).substring(0, 60)
                      }}</span
                    >
                    <small class="mt-1 d-block" style="color:red; font-size:12px">Stok : {{item.miktar}} Standart Stok</small>
                  </td>
                  <td class="product-quantity" data-title="Quantity">
                      <input style="width: 50px;"
                        type="text"
                        :value="item.sepetadet"
                        class="qty h-25"
                         @keyup.enter="update(index,$event.target.value,'sepetadet')"
                      />
                  </td>
                  <td class="text-left" style="padding-top: 17px">{{ item.birim }}</td>

                  <td class="text-left" style="padding-top: 17px">{{ $helper.parabirimi(item.fiyat.liste,'') }}</td>

                  <td class="product-quantity" data-title="Quantity">
                      <input style="width: 100px;"
                        type="text"
                        :value="$helper.parabirimi(item.fiyat.iskontolu,'')"
                        class="qty h-25"
                        @keyup.enter="update(index,$event.target.value,'fiyat.iskontolu')"
                        :disabled = root[hesap.root].disabled

                      />
                  </td>
                  <td style="padding-top: 17px;">{{ item.fiyat.iskonto[0].oran }}</td>
                  <td style="padding-top: 17px">
                     {{ $helper.parabirimi($helper.kdvhesap(item.fiyat.iskontolu,item.kdvt),'') }} 
                  </td>

                  <td class="price" data-title="Total" style="padding-top: 17px">
                    {{ $helper.parabirimi($helper.kdvdahilgoster(item.fiyat.iskontolu,0,item.kdvt).kdvli,'') }}
                  </td>
                  <td class="price" data-title="Total" style="padding-top: 17px; font-weight: 600;">
                    {{ $helper.parabirimi(($helper.kdvdahilgoster(item.fiyat.iskontolu*item.sepetadet,0,item.kdvt).kdvli),'') }}
                  </td>                  
                  <td v-if="item.onay == 0" class="price" data-title="Remove" style="padding-top: 15px">

                    <span class="p-1" style="background:#fe5e3a; font-size: 12px; border-radius:3px; color:white">
                      
                      <a href="javascript:void(0)" @click="gonder(index,'updates')">Gönder</a>

                    </span>
                  </td>
                  <td v-else class="price" data-title="Remove" style="padding-top: 15px">

<span class="p-1" style="background:#484848; font-size: 12px; border-radius:3px; color:white">
  
  Onaylı

</span>
</td>                  <td v-if="item.onay == 0 "  class="price" data-title="Remove" style="padding-top: 15px">

<span class="p-1" style="background:teal; font-size: 12px; border-radius:3px; color:white">
  
  <a href="javascript:void(0)" @click="gonder(index,'onay')">Onayla</a>

</span>
</td>
<td v-else class="price" data-title="Remove" style="padding-top: 15px">

<span class="p-1" style="background:#484848; font-size: 12px; border-radius:3px; color:white">
  
  Onaylı

</span>
</td>  
                </tr>
              </tbody>
            </table>
          </div>

          <div class="white-bg p-3 d-flex">
            <div class="row">
                  <!-- <div class="col-12 mt-3">
                    <select class="form-control">
                      <option value="0">Teslim Türü Seçiniz</option>
                      <option value="1">Kargo</option>
                    </select>
                  </div> -->
                  <div class="col-12 w-100">
                    <textarea v-model="obj.notu"
                      class="form-control d-block"
                      cols="300"
                      rows="3"
                      style="border:none; width: 100%;"
                    ></textarea>
                  </div>

                </div>

          </div>

        </div>

        <div class="col-md-3">
          <div class="row">
            <div class="col-12">
              <div class="white-bg p-3">
                <h2 class="h2">Teklif Özeti</h2>
                <div class="table-responsive">
                  <table class="table">
                    <tbody>
                      <tr>
                        <td>TOPLAM</td>
                        <td>
                          <strong>{{ $helper.parabirimi(toplam,pb) }}</strong>

                        </td>
                      </tr>
                      <tr>
                        <td>İSKONTO</td>
                        <td>
                          <strong>{{ $helper.parabirimi(toplam-tutar,pb) }}</strong>

                        </td>
                      </tr>
                      <tr>
                        <td>ARA TUTAR</td>
                        <td>
                          <strong>{{ $helper.parabirimi(tutar,pb) }}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>KDV</td>
                        <td>
                          <strong>{{ $helper.parabirimi(kdv,pb) }}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>TUTAR</td>
                        <td>
                          <strong>{{ $helper.parabirimi(tutar+kdv,pb) }}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding-top:20px">GEÇERLİLİK SÜRESİ</td>
                        <td style="padding-top:20px">
                          {{ $helper.trtgosternoktali(obj.gecerlilik) }}
                        </td>
                      </tr>                      
                      <!-- <tr class="bg-light">
                        <td>Cari Bakiye</td>
                        <td>
                          <strong>{{
                            source.bakiye + ' '+hesap.pb
                          }}</strong>
                        </td>
                      </tr>
                      <tr class="bg-light">
                        <td>Cari Limiti</td>
                        <td>
                          <strong>{{
                            source.risk+ ' '+hesap.pb
                          }}</strong>
                        </td>
                      </tr> -->
                    </tbody>
                  </table>
                </div>
                <div class="row" v-if="hesap.root == 1">
                  <div class="col-5">
                    <button class="btn btn-orange btn-lg d-inline w-100 mt-3" @click="cariyegonder(true)"> PDF Oluştur </button>                    
                  </div>
                  <div class="col-7">
                    <button class="btn btn-yellow btn-lg d-inline w-100 mt-3" @click="cariyegonder(false)"> Cariye Gönder </button>                    
                  </div>
                </div> 
                <button class="btn btn-blue btn-lg d-inline w-100 mt-3" @click="siparisekle(posts)" >
                  Siparişe Gönder
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- <fotoModal :ad="secilen.ad" :img="secilen.fotos" /> -->
  </div>
</template>

<script>

// import { req } from "@/plugins/axios";
// import fotoModal from "../../components/foto";
// import altmenu from "@/components/altmenu";

export default {

  components: {
    // fotoModal,
    // altmenu,
  },
  data() {
    return {
      source: this.$store.getters.getCari.aktif,
      pb:'USD',
      root:{
        0:{disabled:true,
          text:'İste'
        },
        1:{disabled:false, text:'Oluştur'}

      },
      posts: [],
      secilen: {
        fotos: "",
        ad: "",
      },
      mesaj: {
        msg: "Liste Fiyatları KDV hariç olarak listelenmektedir. Stok miktar limiti aktiftir",
        tip: "light",
      },

      obj:{},
      notu: "Firma Teklif Şablon",
      gecerlilik:'',
      // siparis: {
      //   cKod: this.$store.getters.getCari.aktif.kod,
      //   cari: this.$store.getters.getCari.aktif.unvan,
      //   plasiyer: this.$store.getters.getHesap.kid,
      //   teslim: 1,
      //   odemeTip: 0,
      //   toplam: 0,
      // },
      hesap:this.$store.getters.getHesap,
    };
  },
  computed: {

    toplam() {
      return this.posts.reduce((acc, item) => acc +( item.fiyat.liste * item.sepetadet), 0);
    },
      kdv() {
      return this.posts.reduce((acc, item) => acc +( this.$helper.kdvhesap(item.fiyat.iskontolu,item.kdvt) * item.sepetadet), 0);
    },
      tutar() {
      return this.posts.reduce((acc, item) => acc +( this.$helper.kdvdahilgoster(item.fiyat.iskontolu,0,item.kdvt).kdvli * item.sepetadet), 0); // kdv yukarıda eklenior
    },

  }, //AMK
  created() {
    //this.masrafGetir();
    this.getir();

    this.$store.commit("setLoading",[true,'Bekleyiniz'])

  },

  methods: {
    getir() {
      this.$request.post("crm/teklif/detay/", {id:this.$route.params.seri},this.hesap).then((response) => {
      this.posts = response.data.satir;
      this.obj = response.data
      this.$store.commit("setLoading",[false,'...'])
    });
    },

    gonder(index,func) {
      if (this.hesap.root==1) {
        let source = this.posts[index];
      this.$swal.fire({
        title: "Onaylıyor musunuz?",
        text: "Satır Düzenleniyor ...",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Evet",
        showCloseButton: true,
        cancelButtonText: "Hayır",

        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.$store.commit("setLoading",[true,'Bekleyiniz'])
          let objs = {
                id:this.obj.id,
                sid:source.sid,
                iskonto:source.fiyat.iskonto[0].oran,
                iskontolu:source.fiyat.iskontolu,
                mail:this.obj.ekleyenmail,
                sepetadet:source.sepetadet
          }
          this.$request.post("crm/teklif/"+func, objs,this.hesap).then((response) => {
            this.$store.commit("setLoading",[false,'...'])
              if (func=='onay') source.onay = 1
              this.$swal.fire({
              position: "top-end",
              icon: "success",
              title: "İşlem Başarılı",
              showConfirmButton: false,
              timer: 2000,
              });
            })
        }
      })
      }
      else {
        this.$swal.fire({
              position: "top-end",
              icon: "error",
              title: "Yetkisiz işlem",
              showConfirmButton: false,
              timer: 2000,
              });
      }

    },

    teklifekle() {
      this.$swal({
        title: "Onaylıyor musunuz?",
        text: "Teklif yönetim onayına gidecek",
        icon: "warning",
        //showCancelButton: true,
        confirmButtonText: "Evet",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.$store.commit("setLoading",[true,'Bekleyiniz'])
          let obj = {
                ckod:this.source.kod, //'MS.001050',
                notu: this.notu,
                entegrekodu :this.hesap.entegrekodu,
                kid:this.hesap.kid,
                baslik:this.source.unvan,
                gecerlilik:this.gecerlilik,
                satir: this.posts
          }
          this.$request.post("crm/teklif/add", obj,this.hesap).then((response) => {
            console.log(response)
              let bildirimObje = {
                tip:2,
                alias:'Teklif',
                renk:'info',
                link:'teklif',
                seri:"T",
                sira:response.id,
                kid:this.hesap.kid,
                baslik:this.source.unvan,
                ckod:this.source.kod,
                names:this.hesap.kad// sadece mail için
              }
              this.$request.post("crm/bildirim/add", bildirimObje,this.hesap)
              setTimeout(() => {
                this.$store.commit("setLoading",[false,'...'])

                  this.$swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Teklif Onaya Gönderildi",
                  showConfirmButton: false,
                  timer: 2000,
                });
              }, 1000);
            })
        }
      })
    },

    deletus(arr, guid) { // burayı endpoint de silindiği için burada db den silmiyoruz
      // req.post("basket/delete", {
      //   cKod: this.obj.ckod,
      //   guid: guid,
      // });
      let index = arr.findIndex((obj) => obj.guid == guid);
      if (index !== -1) {
        arr.splice(index, 1);
        this.$store.getters.getCari.aktif.success--
        //this.$store.commit('updateBasket' , {nerden : arr[index].nerden,adet : -1})

      }
    },
   //arama daki sepet update ile farklı orada hariçten 1 tane daha input var (adet hesaplama)
    update(index,yeni,alan) {
      this.$store.commit("setLoading",[true,'Bekleyiniz'])
      let source = this.posts[index];
      this.$store.commit("setLoading",[false,'Bekleyiniz'])
      if (alan =='sepetadet') { source.sepetadet = yeni }
      else {
        let indirim = source.fiyat.liste - yeni
        let news = (indirim/source.fiyat.liste) * 100
        source.fiyat.iskonto[0].oran = this.$helper.parabirimi(news,'').replace(',','.')

        source.fiyat.iskonto[0].tutar = yeni;
        source.fiyat.iskonto[1].tutar = yeni;
        source.fiyat.iskonto[2].tutar = yeni;
        source.fiyat.iskonto[3].tutar = yeni;

        source.fiyat.iskonto[0].fark = indirim;

        source.fiyat.iskontolu = yeni;
        console.log(source.fiyat)


      }

    },

    cariyegonder(status) {
      if (status) {
        this.$store.commit("setLoading",[true,'Bekleyiniz'])
        setTimeout(() => {
          this.$swal.fire({
              position: "top-end",
              icon: "error",
              title: 'Şablon bulunamadı',
              showConfirmButton: false,
              timer: 2000,
            });
            this.$store.commit("setLoading",[false,'Bekleyiniz'])

        }, 2000);

      }
      else {
        this.$swal.fire({
              position: "top-end",
              title:"Bu işlem için yetkiniz bulunmuyor",
              showConfirmButton: false,
              timer: 1500,
            });
      }

    },
  },
};
</script>
<style scoped>

.btn-sm {
  font-size:25px !important
}

.btn {
  font-size:43px !important;
}
small {
  font-size:24px
}
.fs12 {
  font-size: 12px !important;
}
.fs13 {
  font-size: 33px !important;
}
.fs14 {
  font-size: 14px !important;
}
.satir:hover {
  background-color: #ffc7bb;
  cursor: pointer;
}
.fa-times {
  cursor: pointer;
}
.price {
  padding-top: 20px;
}
.fiyat {
  float: left;
  width: 60px;
  height: 24px !important;
  border: 1px solid #ddd;
  background-color: transparent;
  text-align: center;
  margin-top: -5px;
}
.qty {
  float: left;
  width: 60px;
  /* height: 24px !important; */
  border: 1px solid #ddd;
  background-color: transparent;
  text-align: center;
  padding: 0;
  margin: 3px;
}
.minus,
.plus {
  background-color: #eee;
  display: block;
  float: left;
  cursor: pointer;
  border: 0;
  padding: 0;
  width: 22px;
  height: 22px !important;
  line-height: 14px;
  text-align: center;
  font-size: 20px;
  margin: 4px;
}
table thead {
  border: none;
  font-size: 12px;
  font-weight: 500;
}
table tbody {
  border: none;
  font-size: 13px;
  font-weight: 400;
}
@media screen and (max-width: 600px) {
  table {
    border: 0;
  }

  table caption {
    font-size: 1.3em;
  }

  table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  table tr {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: 0.625em;
  }

  table td {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: 0.8em;
    text-align: right;
  }

  table td::before {
    /*
    * aria-label has no advantage, it won't be read inside a table
    content: attr(aria-label);
    */
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
  }

  table td:last-child {
    border-bottom: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/teklif/detay.vue